<template>
<div>

<div v-if="spinner">
  <spinner v-bind:spinner='spinner'></spinner>
</div>    

<div v-else>
    
  <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <h4>PRODOTTO</h4>
  <product-info v-bind:productId="item.productId"></product-info>
  
  <button v-if="btn1" @click="setColorSelection(),btn2 =! btn2" class="btn btn-info mt-2 mb-2 mr-2">
    <i v-bind:class="!btn2 ? 'far fa-eye-slash' : 'far fa-eye'" class="mr-3"></i>
    {{!btn_color ?'MOSTRA TABELLA COLORI':'NASCONDI TABELLA COLORI'}}</button>
  <button v-if="btn2" @click="setSizeSelection(),btn1 =! btn1" class="btn btn-info mt-2 mb-2">
    <i v-bind:class="!btn1 ? 'far fa-eye-slash' : 'far fa-eye'" class="mr-3"></i>
    {{!btn_size ?'MOSTRA TABELLA MISURE':'NASCONDI TABELLA MISURE'}}</button>
  

   <div class="row">
      
      <div class="col-3">
        <color-list v-bind:selection="productColors" v-if="btn_color" @update="setColor"></color-list>
      </div>

      <div class="col">
        <div v-if="btn_size">
          <size-list v-if="sizeSystem" @swap="sizeSystem=false" v-bind:selection="sizeList"  @update="setSize"/>
          <company-size-list v-else @swap="sizeSystem=true"  v-bind:selection="sizeList" @update="setSize"></company-size-list> 
        </div>
      </div> 


    </div>
  
     <h4 class="description text-center"><strong>MODIFICA QUANTITA' VARIANTI</strong></h4>
    <!-- TABLE -->
    <div  class="table-responsive">              
      <table class="table table-bordered table-sm" id="dataGrid">
        <thead class="thead-light">
        <tr>
          <th 
          class = "text-center"
            v-bind:style="{ color: index > 1 ? 'black':'blue', backgroundColor : index > 1 ? '#9ACD32':'' }"
            v-for="(col,index) in cols" :key="index">
          
            <span v-bind:style="{ color: col!='colore' ? 'black':'blue' }">{{col}}</span>

          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index1) in rows" :key="index1">

          <td v-for="(col,index2) in cols" :key="index2">
            <div style='color : navy' v-if = "col=='colore'">                
              <span  v-if = "col=='colore'"><strong>{{item[col]}}  [ {{item.supplierColor}} ] </strong></span>
                                      
            </div> 
            <div class="text-center" v-else-if = "col==''">
              <i @click="deleteRowColor(item)" data-toggle="tooltip" :title="item.deleteRow==0 ? 'Azzera qtà colore' : 'Ripristina qtà colore'"  :style="{color:item.deleteRow==0 ?'black':'red'}" :class="[item.deleteRow == 0 ? 'far fa-edit' : 'fas fa-edit' ]" class="deleteRow center-text" aria-hidden="true"></i>  
            </div>    
            
          
             
            <div v-else>
            
            

            <input 
            v-bind:style="{ borderWidth:item[col]['qty'] == 0 ? 'medium':'',  borderColor: item[col]['qty'] == 0 ? 'red':''}"
            v-on:keydown="keyHandler($event,'Num')"
            
             v-focus :ref="'id_' +  index1 + index2" :id="'id_' + index1 + index2"    v-model.number="item[col]['qty']"  class="form-control inputClass" type="number"  :placeholder="''" >
            <small v-if="item[col]['qty'] != item[col]['savedQty']"  class="form-text text-muted">Quantità originale <strong>{{item[col]['savedQty']}}</strong></small>
            </div>

          </td>


        </tr>
        </tbody>
      </table>

    <!-- Table -->
    </div>


  
  
  <h3 class="text-center">Totale  <span class="badge badge-success ">{{total}}</span></h3>
  <button :disabled="bt_spinner" @click="confirmEdit()"  class="btn btn-primary mt-2 float-right mr-3 ">
     <i class="fas fa-save mr-2" aria-hidden="true"></i>
    SALVA E PROCEDI
    <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
  
  <button @click="$emit('update','CLOSE')"  class="btn btn-secondary float-left mt-2 ml-3 ">
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
    RITORNA A LISTA PRODOTTI</button>
 
 <!--
  <button @click="resetQty()"  class="btn btn-outline-danger float-left mt-2 ml-2">
     <i class="fas fa-edit mr-2" aria-hidden="true"></i>
    Azzera varianti</button>
-->

<!-- if else -->
</div>



<confirm-box v-if="cb.show">
  <template v-slot:header>
    <strong>{{cb.title}}</strong>    
  </template>

  <template v-slot:body1>
    <h4 class="modalMsg">{{cb.msg1}}</h4>    
  </template>
  <template v-slot:body2>
    <h4><strong>{{cb.msg2}}</strong></h4>    
  </template>

  <template v-slot:footer >

        <button v-if="cb.btn" @click="cb.show=false" type="button" class="btn btn-primary">CHIUDI</button>
        <button v-if="!cb.btn" @click="cb.show=false" type="button" class="btn btn-secondary">NO</button>
        <button v-if="!cb.btn" @click="submit(),cb.show=false" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>

  </template>    
     
  
</confirm-box>


</div> 
</template>

<script>


import api                 from "@/api"
import _                   from "lodash";
import {eanCD,createEAN13} from '@/functions';
import spinner             from '@/components/common/Spinner.vue';
import ColorList           from '@/components/backOffice/ready/ColorList.vue';
import SizeList            from '@/components/backOffice/ready/SizeListUpdateProductStock.vue';
import companySizeList     from '@/components/backOffice/ready/CompanySizeList.vue';
import ProductInfo         from '@/components/product/ProductInfo.vue';
import alertBox            from '@/components/common/AlertBox.vue';
import confirmBox          from '@/components/common/ConfirmBox.vue'
import keyHandler          from '@/components/mixins/keyHandler'

import { mapGetters }      from 'vuex';

export default {
  
  props : ['item'],
  mixins: [keyHandler],

   components: {
    SizeList,ProductInfo,ColorList,spinner,alertBox,confirmBox,companySizeList
   
  },
  data () {
    return {  

      sizeSystem     : false,
      storeId        : 0,
      bt_spinner     : false,  
      btn1           : true,
      btn2           : true,
      spinner        : false,

      total          : 0,
      cols           : [], 
      rows           : [],
      dataItems      : [],

      //colors         : [],
      
      counter        : 0,
    
      cb             : {
        title        : '',
        msg1         : '',
        msg2         : '',
        show         : false,
        btn          : false
        
      },

      msg            : {
        title : '',
        body  : '',
        type  : 0
      },
      

      productColors  : [],
      sizeList       : [],
      file           : '',
      btn_size       : false,
      btn_color      : false,
      

      index          : 0,
      vat            : 0

       
    }
  },
  watch: 
  {
        
    'rows' : 
    {
      
      deep    : true,  
      handler : function(newValue) 
      {                
        this.total = 0
        for(var i = 0; i < newValue.length; i++) 
          {
            var obj = newValue[i];
            Object.entries(obj).forEach(entry => 
            {
              let key   = entry[0];
              
              
              if (key != 'colorId' && key != 'colore' && key != "supplierColor" && key != 'deleteRow' && key != '' )
              {
                
                this.total += Number(entry[1].qty)
              }
                      
            });  
          }                
      }

    }
    
  
  },
  computed: 
  {   
  
    ...mapGetters(['company'])
  
  },
  directives: {
  focus: {
    // directive definition
    inserted: function (el) {
      
      if(el.id=='id_01')
      {
        el.focus()
      }
    }
  }
},
  mounted()
  {
    
  },
  
  async created()
  { 

    var data      = {'productId' : this.item.productId , 'movementId' : this.item.movementId} 
    
    var sp        = {'sp':'spProductMovement'}
    this.spinner  = true
    var json      = Object.assign(data, sp);

    await api.post(json).then(res => {
      if(res.status==200)
        {
            var item = res.data.recordsets
            this.dataItems = item[0]
            
            this.vat = this.dataItems[0].vat
            
            this.storeId = item[0][0].storeId           
            this.counter = item[1][0].counter           
            
            // sizeList del prodotto
            this.sizeList =  _.uniqBy(
            _.map(item[0], function(object) {
              return _.pick(object, ['size','sizeId']);
            }),"sizeId"
          );  
          this.sizeList.forEach(item=>{
            item.newSize = 'N'
          })


          // product colors movement
          this.productColors =  _.uniqBy(
            _.map(item[0], function(object) {
              return _.pick(object, ['colorId','productColor','supplierColor','newColor']);
            }),"colorId"
          );  
          
          
          
          this.barcodeList = item[4]

          this.createGrid(this.sizeList,this.productColors)
                   
                  
        }
        else if(res.status==500)
        {
          
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res.data
          this.msg.type = 1

        } 
        else
        {
          

          this.msg.title = 'ATTENZIONE '
          this.msg.body = res
          this.msg.type = 1
        } 
    }).catch(err => 
    {
      
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1

    }).finally(() => {
      this.spinner = false
    });


    
 
  },
 
      

  methods: 
  {
    
    deleteRowColor(row)
    {   
        if(row.deleteRow == 0)
        {   
        this.cols.forEach(col=>{                    
          if(col != 'colore' && col != '')
          {
           
            row[col].qty = 0

          }
       })
       row.deleteRow = 1
    }
    else
    {
         this.cols.forEach(col=>{                    
          if(col != 'colore' && col != '')
          {
           
            row[col].qty = row[col].savedQty

          }
       })
       row.deleteRow = 0
    }   

    },
    resetAlert()
    {
      
      this.cb.title = 'ATTENZIONE '
      this.cb.msg1  = 'AZZERAMENTO DI TUTTE LE VARIANTI' 
      this.cb.msg2  = 'PROCEDO ?'
      this.cb.btn   = false
      this.cb.show  = true
        
    },

    

    setSize(sizes)
    {


      /*

       // ADD SIZE
      let item = []
      sizes.forEach(size => {
        item = this.sizeList.filter(row => size.sizeId == row.sizeId)
        
        if(item.length==0)
          {
            this.sizeList.push({'sizeId':size.sizeId,'size':size.size,'newSize':'Y'})    
          }

        })
        
        // REMOVE SIZE
        if(sizes.length < this.sizeList.length)
        {         
          let sizeId = 0
          this.sizeList.forEach(size=>
          {
            if(sizes.filter(row => row.sizeId == size.sizeId).length==0)
            {
              sizeId = size.sizeId
            }  
          })

          this.sizeList =  this.sizeList.filter(row => row.sizeId != sizeId )              
          
        }
        */
      

      this.sizeList = sizes 
      this.createGrid(this.sizeList,this.productColors)
    },
    setColor(colors)
    {
      
      // ADD COLORS  
      let item = []
      colors.forEach(color => {
        item = this.productColors.filter(row => color.colorId == row.colorId)
        
        if(item.length==0)
          {
            this.productColors.push({'colorId':color.colorId,'productColor':color.color,'supplierColor':'','newColor':'Y'})    
          }

        })
        
        // REMOVE COLORS
        if(colors.length < this.productColors.length)
        {         
          let colorId = 0
          this.productColors.forEach(color=>
          {
            if(colors.filter(row => row.colorId == color.colorId).length==0)
            {
              colorId = color.colorId
            }  
          })

          this.productColors =  this.productColors.filter(row => row.colorId != colorId )              
          
        }
        
      this.createGrid(this.sizeList,this.productColors)

    },

    setColorSelection()
    {
      //this.selection = this.productColors
      this.btn_color = !this.btn_color      
    },
    setSizeSelection()
    {
      //this.selection = this.sizeList
      this.btn_size = !this.btn_size
    },

    resetQty()
    {
      this.rows.forEach(item=>{
        this.cols.forEach(col=>{
          
          if(col != 'colore')
          {
            //console.log(item[col])
            item[col].qty = 0
          }
        })
        //console.log(item)
        //item.qty = 0
      })
    },


    
  
    createGrid(sizes,colors)
    {

      this.cols = []

      

      this.cols.push('colore') 
      
      this.cols.push('') 

      var productId = this.item.productId

      sizes.forEach(item=>{
            this.cols.push(item.size)
            })
            
          
        
          var arr = []
          var obj = {}
          var tmp = {}

          colors.forEach(color=>{

            obj  = {}
            obj.colorId       = color.colorId
            obj.colore        = color.productColor
            obj.supplierColor = color.supplierColor
            obj.deleteRow     = 0           
            sizes.forEach(size => {
              
              // check item presente sul movimento
              var item          = this.dataItems.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId))                           
              tmp               = {}
              if(item.length == 0)
              {
                 // check item su Barcodes List
                 item = this.barcodeList.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId)) 
              } 

              if(item.length==0)
              {
                this.counter++                
                tmp['id']              = 0
                tmp['qty']             = 0
                tmp['savedQty']        = 0
                tmp['barcode']         = createEAN13(productId,this.counter)
                tmp['productId']       = productId
                tmp['costPrice']       = 0
                tmp['retailPrice']     = 0
                tmp['vat']             = this.vat
                tmp['discount']        = 0
                tmp['colorId']         = color.colorId
                tmp['sizeId']          = size.sizeId
                tmp['supplierColor']   = color.supplierColor


              }
              else
              {
                           
               
                tmp['id']              = item[0].id == undefined ? -1 : item[0].id
                tmp['qty']             = item[0].qty == undefined ? 0 : item[0].qty
                tmp['savedQty']        = item[0].qty == undefined ? 0 : item[0].qty
                tmp['barcode']         = item[0].barcode
                tmp['productId']       = productId
                tmp['costPrice']       = 0
                tmp['retailPrice']     = 0
                tmp['vat']             = this.vat
                tmp['discount']        = 0
                tmp['colorId']         = color.colorId
                tmp['sizeId']          = size.sizeId
                tmp['supplierColor']   = color.supplierColor
                
              } 
              
              obj[size.size] = tmp 
              

            })

             arr.push(obj)


          })


        
        this.rows = arr 
        
        
        

    },


    confirmEdit()
    {
      
      if(this.total == 0)
      {
        this.resetAlert()
        return
      }
      this.submit()
    },

    async submit()
    {

      var items = []
      var obj   = {}
      
      for(var i = 0; i < this.rows.length; i++) 
          {
            var row = this.rows[i];
            Object.entries(row).forEach(entry => 
            {
              let key = entry[0];
              let item = entry[1];
              obj = {}
                            
              if(key !='colore' && key != 'supplierColor' && key != 'colorId' && key != 'deleteRow' && key != '')
              {
                                                  
                obj['productId']      = item.productId
                obj['id']             = item.id 
                obj['barcode']        = item.barcode
                
                obj['costPrice']      = item.costPrice
                obj['retailPrice']    = item.retailPrice
                obj['discount']       = item.discount
                obj['vat']            = item.vat
                obj['qty']            = item.qty
                obj['colorId']        = item.colorId
                obj['sizeId']         = item.sizeId
                obj['qty']            = item.qty 
                obj['supplierColor']  = item.supplierColor

                // riga stock esistente
                if(item.id > 0 && item.qty != item.savedQty)
                {
                  obj['qty']            = item.qty - item.savedQty
                  items.push(obj)
                }
                // riga stock nuova qty > 0
                if(item.id <= 0 && item.qty > 0)
                {
                  items.push(obj)
                }  
                  

              }        
            });  
          }
       
        

        
        console.log('MODIFICA PRODOTTO',items)
        var data    = {}
        data.header = {}
        

        // NESSUNA MODIFICA
        if(items.length == 0)
        {
            console.log('NESSUNA MODIFICA')
            this.$emit('update')
            /*
            this.cb.title = 'ATTENZIONE '
            this.cb.msg1  = 'NESSUNA VARIANTE MODIFICATA.'
            this.cb.msg2  = ''
            this.cb.btn   = true
            this.cb.show  = true

          return
          */
        }
        

        data.header.movementId  = this.item.movementId
        
        data.header.storeId     = this.storeId        
        data.header.productId   = this.item.productId
        data.header.counter     = this.counter
        data.body               = items

        //console.log(data.header,data.body)

        const sp    = {'sp':'spUpdateProductMovement'}
        const json  = Object.assign(data, sp);

        this.bt_spinner = true
        this.cb.show = false

        await api.post(json).then(res => {
          if(res.status==200)
            {
              if(this.total==0)
              {
                this.$emit('update','CLOSE')
              }
              else
              {
                this.$emit('update')
              }
            
               /* SHOPIFY SYNC PRODUCT/VARIANTS */
               if(this.company.shopify)
                {

                   /* SHOPIFY SYNC PRODUCT/VARIANTS */
                if(this.company.shopify)
                {
                    api.shopifyCreateProductVariants(this.company.Id,this.item.productId)
                                            
                }    


                     
                }    


            }
            else if(res.status==500)
            {
              
              this.cb.title = 'ATTENZIONE '
              this.cb.msg1  = res.data
              this.cb.btn   = true
              this.cb.show  = true


            } 
            else
            {
              this.cb.title = 'ATTENZIONE '
              this.cb.msg1  = res
              this.cb.msg2  = ''
              this.cb.btn   = true
              this.cb.show  = true

              
            } 
        }).catch(err => 
        {
              this.cb.title = 'ATTENZIONE '
              this.cb.msg1  = err.message
              this.cb.msg2  = ''
              this.cb.btn   = true
              this.cb.show  = true

          
          

        }).finally(() => {
          this.bt_spinner = false
        });
        


    },

      

    }
  
}
</script>

<style scoped>
.btn_back
{
  color:blue;
}
.description
{
  color:chocolate
}
.modalMsg{

  color : brown;
}
.inputClass{
  font-weight       : bold;
  
  }



input[type=text]:disabled {
  background : white;
  color      : navy;
   
}
input[type=number] {
  border: 1px solid;
 
}
input[type=number]:focus {
 border: 0px ;
 
 
 
}

p,h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
}

.modal-footer {  
  justify-content: space-between;  
}
.deleteRow
    {
      
      cursor : pointer; 
    }

</style>